<script>
export default {}
</script>
<template>
  <div class="media-list media-list-hover media-list-divided">
    <slot></slot>
  </div>
</template>
